module.exports = __webpack_public_path__ + "media/images/lp/plight6-pc-f74ca0032cec0be016efbb474ded2ae2.png";